import { useState } from "react"
import useMainContentTab from "../../../../stores/useMainContentTab.jsx"
import useActiveTabStore from "../../../../stores/useActiveTab.jsx"
import useActiveModel from "../../../../stores/useActiveModel.jsx"

export default function ContactForm() {
    const setMainContentTab = useMainContentTab((state) => state.setMainContentTab)
    const setActiveTab = useActiveTabStore((state) => state.setActiveTab)
    const setActiveModel = useActiveModel((state) => state.setActiveModel)

    const [form, setForm] = useState({
        name: "",
        email: "",
        message: "",
    })
    const [submitted, setSubmitted] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        setErrorMessage("") // Clear any previous error

        const formData = new FormData(e.target)
        formData.append("access_key", "b79b8057-183c-4314-a244-5c2d80288690")
        const object = Object.fromEntries(formData.entries())
        const json = JSON.stringify(object)

        try {
            const res = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: json
            }).then((res) => res.json())

            if (res.success) {
                console.log("Success", res)
                setSubmitted(true)
                setForm({ name: "", email: "", message: "" })
                setMainContentTab("ThankyouScreen")
                setActiveModel("thankyou")
                setActiveTab()
            } else {
                console.error("Error submitting form:", res)
                // Set the error message from the response so the user can see what went wrong.
                setErrorMessage(res.message)
            }
        } catch (error) {
            console.error("Error submitting form:", error)
            setErrorMessage("An error occurred. Please try again later.")
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="flex items-center justify-center">
            <div className="flex flex-col w-full max-w-4xl shadow-glow backdrop-blur-sm pointer-events-auto">
                {/* Left section */}
                <div className="w-full p-4 border-slate-700 border-b">
                    <h1 className="text-3xl font-bold text-white text-center mb-4">Get in Touch!</h1>
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                placeholder="Enter your name"
                                className="w-full px-4 py-2 bg-gray-900 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-sky-500"
                                required
                            />
                        </div>
                        <div>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                placeholder="Enter your email"
                                className="w-full px-4 py-2 bg-gray-900 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-sky-500"
                                required
                            />
                        </div>
                        <div>
                            <textarea
                                id="message"
                                name="message"
                                value={form.message}
                                onChange={handleChange}
                                placeholder="Your message..."
                                rows="2"
                                className="w-full px-4 py-2 bg-gray-900 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-sky-500"
                                required
                            ></textarea>
                        </div>
                        <button
                            type="submit"
                            disabled={isLoading}
                            className={`w-full py-2 px-4 text-white rounded-md transition duration-200 ease-in-out ${isLoading ? "bg-gray-500 cursor-not-allowed" : "bg-sky-500 hover:bg-sky-600"}`}
                        >
                            {isLoading ? "Sending..." : "Send Message"}
                        </button>
                        {/* Display error message if there is one */}
                        {errorMessage && (
                            <div className="mt-2 text-center text-red-500">
                                {errorMessage}
                            </div>
                        )}
                    </form>
                </div>
                {/* Right section */}
                <div className="w-full flex flex-col items-center justify-center p-4 mb-4">
                    <h2 className="text-2xl font-bold text-white mb-4">Otherwise...</h2>
                    <p className="text-gray-300 mb-6 text-center">
                        If you’d rather simply explore my work without sending a message, you can jump straight to the end.
                    </p>
                    <button
                        onClick={() => {
                            setMainContentTab("ThankyouScreen")
                            setActiveModel("thankyou")
                            setActiveTab()
                        }}
                        className="py-2 px-4 bg-sky-500 hover:bg-sky-600 text-white rounded-md transition duration-200 ease-in-out"
                    >
                        End Portfolio!
                    </button>
                </div>
            </div>
        </div>
    )
}

